module.exports = {"220622100":"靖宇镇","220622101":"三道湖镇","220622102":"龙泉镇","220622103":"那尔轰镇","220622104":"花园口镇","220622105":"景山镇","220622106":"赤松镇","220622201":"蒙江乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220622.json
// module id = 594
// module chunks = 0